export enum PurchaseReasonEnum {
    MARKETING_ASSISTANT = 'marketing_assistant_notification_push',
    CINEMA_WEBSITE = 'cinema_website',
    WEB_APP = 'web_app',
    AD_CLICK_DIRECT = 'ad_click_direct',
    AD_CLICK_SAME_SESSION = 'ad_click_same_session',
    MOVIE_LANDINGPAGE = 'movie_landingpage',
    SHOWTIMES_FINDER = 'showtimes_finder'
}
